<template>
  <b-modal id="prepare-info-modal" no-close-on-backdrop size="md" v-model="show" centered hide-footer>
    <template #modal-header>
      <h5 id="prepare-info-modal___BV_modal_title_" class="modal-title">{{ $t('common.prepare_info') }}</h5>
      <button class="bg-transparent border-0" type="button" aria-label="Close" @click="savePrepareInfo()"><img
          src="~@/assets/images/download-chart.svg" alt=""></button>
    </template>
    <iframe class="w-100 my-3" style="min-height: 300px">

    </iframe>

    <div class="col-12">
      <button class="btn btn-block btn-secondary py-2 text-white" @click="closeInfoModal(true)">
        {{ $t('common.i_agree') }}
      </button>
    </div>
    <div class="col-12">
      <button class="btn btn-block bg-transparent" @click="closeInfoModal(false)">
        {{ $t('buttons.cancel') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import fileSave from "@/helpers/fileSave";

export default {
  name: "prepareInfoModal",
  props: {
    time_table_info: {
      required: false,
      type: Object
    },
    selected_specialization:{
      required:false,
      type:Object,
    },
    show: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed:{
    specializationTitle(){
      return this.selected_specialization ? `Подготовка ${this.selected_specialization.title}` : 'Подготовка'
    }
  },
  methods: {
    savePrepareInfo() {
      this.$store.dispatch('getPrepareInfo', {
        service_id: this.time_table_info.service_prepare_info_id,
        pdf: true
      }).then(response => {
        let byteCharacters = atob(response.data);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        fileSave({
          blob: byteArray,
          type: 'application/pdf',
          name: this.specializationTitle,
        });
      })
    },
    getPrepareInfo() {
      this.$store.dispatch('getPrepareInfo', {service_id: this.time_table_info.service_prepare_info_id}).then(response => {
        this.seanceLoading = false
        setTimeout(() => {
          let doc = document.querySelector('#prepare-info-modal iframe').contentWindow.document;
          doc.open();
          doc.write(response.content);
          doc.close();
        }, 400)

      })
    },
    closeInfoModal(val) {
      this.$emit('closePrepareModal', val)
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && this.time_table_info) this.getPrepareInfo()
      }
    }
  }
}
</script>

<style scoped>

</style>